<template>
  <v-container class="ma-0 pa-0 pb-8">
    <v-row class="pt-10 px-8 pb-12">
      <strong>Filtros</strong>
      <v-spacer></v-spacer>
      <v-btn small class="elevation-0" style="border:1px solid #ddd" @click="removeFilter">
        <v-icon small class="mr-1">mdi-filter-off</v-icon>Limpiar
      </v-btn>

      <v-text-field label="Nombre" v-model="model.name" />

    </v-row>

    <v-card style="position:absolute; bottom:0; width:100%;" tile color="primary">
      <v-list-item link dark @click="apply">
        <v-list-item-content>
          <strong>Filtrar ({{ counter }})</strong>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'BrandsFilter',
  data: () => ({
    model: {
      id: '',
      name: '',
      description: '',
      // agency_ids como CSV en el input (lo convertimos a lista al construir el query)
      agency_ids: '',
      // rango de fechas (usamos filter[date_between])
      created_between: [],  // [yyyy-mm-dd, yyyy-mm-dd]
    },
  }),
  computed: {
    createdBetweenLabel () {
      const d = this.model.created_between
      return (Array.isArray(d) && d.length === 2 && d[0] && d[1]) ? `${d[0]} a ${d[1]}` : ''
    },
    counter () {
      let c = 0
      const m = this.model
      if (m.id) c++
      if (m.name) c++
      if (m.description) c++
      if (m.agency_ids) c++
      if (Array.isArray(m.created_between) && m.created_between.length === 2 && m.created_between[0] && m.created_between[1]) c++
      return c
    },
  },
  created () {
    // restaurar si hay filtros guardados
    const saved = localStorage.getItem('selectorFiltersBrands')
    if (saved) {
      try { this.model = JSON.parse(saved) } catch (e) {}
    }
  },
  methods: {
    closeDatePicker (dates) {
      return Array.isArray(dates) && dates.length === 2 && dates[0] && dates[1]
    },
    apply () {
      // Construimos QS con los filtros permitidos que mencionaste:
      // Allowed: id, name, description, activity_type_id, user_id, client_id,
      // contact_mode_id, contact_id, date_between, sales.influencer_id, agencies.id, agency_id
      // Para marcas usamos: id, name, description, date_between, agencies.id/agency_id

      let qs = ''
      const m = this.model

      if (m.id) qs += `&filter[id]=${encodeURIComponent(m.id)}`
      if (m.name) qs += `&filter[name]=${encodeURIComponent(m.name)}`
      if (m.description) qs += `&filter[description]=${encodeURIComponent(m.description)}`
      if (Array.isArray(m.created_between) && m.created_between.length === 2 && m.created_between[0] && m.created_between[1]) {
        qs += `&filter[date_between]=${m.created_between[0]},${m.created_between[1]}`
      }

      // agency ids: soporta uno o varios (CSV)
      const ids = (m.agency_ids || '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
      if (ids.length) {
        // según tu backend puedes usar agencies.id o agency_id
        // dejo ambos por compatibilidad: (si uno sobra, ignorará)
        const csv = ids.join(',')
        qs += `&filter[agencies.id]=${csv}&filter[agency_id]=${csv}`
      }

      // Guardar en localStorage como ya haces en otros módulos
      localStorage.setItem('selectorFiltersBrands', JSON.stringify(this.model))
      localStorage.setItem('filtersBrands', JSON.stringify(qs.slice(1))) // quitamos el primer &
      localStorage.setItem('filtersBrandsLength', String(this.$propsLength ?? this.counter))

      this.$nextTick(() => {
        this.$emit('filtersBrands', false)
      })
    },
    removeFilter () {
      this.model = {
        id: '',
        name: '',
        description: '',
        agency_ids: '',
        created_between: [],
      }
      localStorage.removeItem('selectorFiltersBrands')
      localStorage.removeItem('filtersBrands')
      localStorage.removeItem('filtersBrandsLength')
      this.$nextTick(() => {
        this.$emit('filtersBrands', false)
      })
    },
  }
}
</script>

<style>
.v-text-field {
  padding-top: 10px;
  margin-top: 0px;
}
</style>
